import { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import {
  ClickOutsideDetector,
  IconFilter,
  ToggleInput,
  ToggleSize,
  IconExpand,
  IconClose,
} from '@ui/src';
import { BlacklistFormValues } from '../../hoc/types';
import { SettingItemTypes } from './types';

import cn from './blacklist.module.css';

const SettingItem = ({
  control,
  item,
  allSettingsEnabled,
  setAllSettingsEnabled,
  settings,
  setSettings,
  isEditable,
  blacklistId,
  setValue,
  fields,
}: SettingItemTypes) => {
  const [subTypesVisible, setSubTypesVisible] = useState(false);
  const [haveEnabledSettings, setHaveEnabledSettings] = useState(false);

  useEffect(() => {
    if (fields) {
      const currentSettings: Record<string, boolean> = {};

      item.subTypes?.forEach((subType) => {
        // @ts-ignore
        if (fields[subType.value]?.toString()) {
          // @ts-ignore
          currentSettings[subType.value] = fields[subType.value];
        }
      });

      if (
        Object.keys(currentSettings)?.length &&
        Object.keys(currentSettings)?.filter((value) => currentSettings[value])
          ?.length
      ) {
        setHaveEnabledSettings(true);
      } else {
        setHaveEnabledSettings(false);
      }
    }
  }, [fields, item]);

  return (
    <div className={cn.formToggleWrapper}>
      <div className={cn.formToggleItem}>
        <Controller
          control={control}
          name={item.value as keyof BlacklistFormValues}
          defaultValue={false}
          render={({ field: { onChange, value } }) => (
            <ToggleInput
              title={item.title}
              name={`toggle-${item.value}`}
              size={ToggleSize.MEDIUM}
              value={item.value}
              onChange={(e) => {
                onChange(e.target.checked);

                if (!e.target.checked) {
                  item?.subTypes?.forEach((subType) => {
                    setValue(subType.value as keyof BlacklistFormValues, false);
                  });
                }

                if (allSettingsEnabled && !e.target.checked) {
                  setAllSettingsEnabled(false);
                }

                if (settings && setSettings) {
                  setSettings({
                    ...settings,
                    [item.value]: e.target.checked,
                  });
                }
              }}
              checked={value as boolean}
              disabled={Boolean(!isEditable && blacklistId)}
              tabIndex={!isEditable && blacklistId ? -1 : 0}
            />
          )}
        />
      </div>
      <ClickOutsideDetector setOptionsListVisible={setSubTypesVisible}>
        <div className={cn.subTypesWrapper}>
          <button
            type="button"
            className={`${cn.subTypesButton} ${
              subTypesVisible ? cn.active : ''
            } ${haveEnabledSettings ? cn.haveEnabledSettings : ''}`}
            onClick={() => setSubTypesVisible(!subTypesVisible)}
          >
            <IconFilter width={18} height={18} />
          </button>
          {subTypesVisible && (
            <div className={cn.subTypesMenu}>
              <div className={cn.subTypesMenuTitle}>
                Select lists to check only in them
              </div>
              <div className={cn.subTypeMenuItems}>
                {item?.subTypes?.map((subType) => (
                  <Controller
                    key={subType.value}
                    control={control}
                    name={subType.value as keyof BlacklistFormValues}
                    defaultValue={false}
                    render={({ field: { onChange, value } }) => (
                      <button
                        type="button"
                        className={`${cn.subTypeButton} ${
                          value ? cn.active : ''
                        }`}
                        onClick={() => {
                          onChange(!value);

                          if (settings && setSettings) {
                            setSettings({
                              ...settings,
                              [subType.value]: !value,
                            });
                          }
                        }}
                      >
                        {value ? (
                          <IconClose
                            width={16}
                            height={16}
                            className={cn.activeIcon}
                          />
                        ) : (
                          <IconExpand />
                        )}
                        <div className={cn.subTypeTitle}>{subType.title}</div>
                      </button>
                    )}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </ClickOutsideDetector>
    </div>
  );
};

export default SettingItem;
